import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import { ProductCatalogEmbroideryPlacement } from '../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { B2bLogoFormValues } from '../../../../../containers/EmbroideryContainer/types'
import { PlacementSelector } from '../../../Modal/primitives/selectors/PlacementSelector/PlacementSelector'
import { EmbroideryOptionWrapper } from '../../../Modal/primitives/shared-form-styles'

interface Props {
  labelId: string
  placementOptions: ProductCatalogEmbroideryPlacement[] | null | undefined
  form: FormStore<B2bLogoFormValues>
  disabled?: boolean
}

/** Placement selector used by the team-store B2B logo form. */
export const TeamStoreLogoPlacement: FC<Props> = ({
  labelId,
  placementOptions,
  form,
  disabled,
}) => {
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()

  const logoPlacement = useStoreState(form, s => s.values.logoPlacement)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('logoPlacement') ? form.getError('logoPlacement') : undefined
  )

  if (!placementOptions) return null

  return (
    <EmbroideryOptionWrapper>
      <PlacementSelector
        errorMessage={errorMessage ?? undefined}
        label={fixtures.logoPlacement}
        labelId={labelId}
        onSelectPlacement={placement => form.setValue('logoPlacement', placement)}
        placementOptions={placementOptions}
        selectedPlacementOption={logoPlacement ?? placementOptions[0]}
        disabled={disabled}
      />
    </EmbroideryOptionWrapper>
  )
}
